import React, { useContext } from "react";
import { TestsContext } from "../../contexts";
import { ShadowBox, Stat } from "../common";
import { AboutMaximumLatency, AboutAverageLatency, AboutMinimumLatency } from ".";
import { Row, Col } from "react-bootstrap";

export const Stats = (props) => {
  const { className } = props;
  const { tests } = useContext(TestsContext);
  const { averageLatency, minimumLatency, maximumLatency } = tests;

  return (
    <>
      <Row>
        <Col>
          <ShadowBox className='p-2'>
            <Stat title='Average Latency' value={averageLatency} info={<AboutAverageLatency></AboutAverageLatency>} />
          </ShadowBox>
        </Col>
        <Col>
          <ShadowBox className='p-2'>
            <Stat title='Minimum Latency' value={minimumLatency} info={<AboutMinimumLatency></AboutMinimumLatency>} />
          </ShadowBox>
        </Col>
        <Col>
          <ShadowBox className='p-2'>
            <Stat title='Maximum Latency' value={maximumLatency} info={<AboutMaximumLatency></AboutMaximumLatency>} />
          </ShadowBox>
        </Col>
      </Row>
    </>
  );
};
